import React from "react";
import { Button, Card, Dropdown, Tooltip, theme } from "antd";
import { useTranslation } from "react-i18next";
import {
  FolderOutlined,
  FolderOpenOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  ShareAltOutlined,
  TeamOutlined
} from "@ant-design/icons";

const { Meta } = Card;

const FolderCard = ({ folder, onOpen, onShare, onDelete }) => {
  const { t } = useTranslation("dashboard");
  const { token } = theme.useToken();
  const isShared = folder.sharedWith && folder.sharedWith.length > 0;
  const menuItems = [
    {
      key: "open",
      label: t("Open"),
      icon: <FolderOpenOutlined />,
      onClick: onOpen
    },
    {
      key: "share",
      label: t("Share / Manage Access"),
      icon: <ShareAltOutlined />,
      onClick: onShare
    },
    {
      key: "delete",
      label: t("Delete"),
      icon: <DeleteOutlined />,
      danger: true,
      onClick: onDelete
    }
  ];

  return (
    <Card
      hoverable
      className="file-card folder-card"
      cover={
        <button
          type="button"
          onClick={onOpen}
          className="file-icon folder-icon"
          aria-label={`${t("Open")}: ${folder.name}`}
        >
          <FolderOutlined style={{ fontSize: 48, color: folder.color || token.colorPrimary }} />
        </button>
      }
      actions={[
        <Dropdown
          menu={{ items: menuItems }}
          placement="bottomRight"
          trigger={["click"]}
          key="actions"
        >
          <Button
            type="text"
            block
            icon={<EllipsisOutlined />}
            aria-label={t("More actions")}
            className="file-card__more"
          />
        </Dropdown>
      ]}
      onDoubleClick={onOpen}
    >
      <Meta
        title={
          <Tooltip title={folder.name}>
            <div onClick={onOpen} className="file-title">
              {isShared && <TeamOutlined className="file-shared-icon" aria-label={t("Share")} />}
              <span className="file-title__text">{folder.name}</span>
            </div>
          </Tooltip>
        }
        description={
          <div className="file-description">{folder.description || t("No description")}</div>
        }
      />
    </Card>
  );
};

export default FolderCard;
